import { Suspense } from 'react';
import { createCrumbHandle } from '../../utilities/auth';
import Loader from '../../globalComponents/loader/DPLoader';
import BatchConfigListing from '../../pages/BatchConfig/components/BatchConfigListing';
import CreateEditBatchConfigPage from '../../pages/BatchConfig/components/CreateEditBatchPage';


const batchConfigRoute = [
  {
    path: '/batch-config/:assetId',
    handle: createCrumbHandle('Batch Config'),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <BatchConfigListing />
          </Suspense>
        ),
        // loader: validatePermission('BatchConfig_View_R'),
      },
      {
        path: "createEditBatchConfig/:batchConfigurationId?",
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <CreateEditBatchConfigPage />
          </Suspense>
        ),
        //  loader: validatePermission('BatchConfig_Manage_A'),
         handle: createCrumbHandle('Create Batch Config'),
      }
    ]
  },
];

export default batchConfigRoute;
